import component from "./TextArea";

export default component;
